export enum RoutesNotifications {
  NOTIFICATIONS = 'notifications',
}
